import { render, staticRenderFns } from "./record_list.vue?vue&type=template&id=268148ce&scoped=true&"
import script from "./record_list.vue?vue&type=script&lang=js&"
export * from "./record_list.vue?vue&type=script&lang=js&"
import style0 from "./record_list.vue?vue&type=style&index=0&id=268148ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268148ce",
  null
  
)

export default component.exports